import React from 'react'

import { t } from 'src/lib/i18n-react'
import { Button, Box } from '@chatterbug/aaron'

type Props = {
  onBookAsTrainer: (appointmentId: string) => unknown
  appointmentId: string
}

const AppointmentBookable: React.FC<Props> = ({
  onBookAsTrainer,
  appointmentId,
}) => {
  // free floating LL, up for grabs, show 'Book It'
  return (
    <Box gridColumn={{ _: '1/-1', tablet: '2/-1' }}>
      <Button
        data-testid="book-button"
        as="submit"
        onClick={() => onBookAsTrainer(appointmentId)}
        style={{ width: '100%' }}
        type="primaryAdvanced"
      >
        {t('Book It')}
      </Button>
    </Box>
  )
}

export default AppointmentBookable
